import { Link } from "react-router-dom";
import "./NewBornInfo.css";

export default function QuanInfo(props) {
  return (
    <main className="nbx">
      {/* HERO */}
      <section className="nbx-hero">
        <div className="container">
          <h1 className="nbx-title">Đặc Điểm Nổi Trội của Sản Phẩm</h1>
          <p className="nbx-sub">
            Tã dán Rumi đạt chứng nhận tiêu chuẩn <strong>SGS</strong> &{" "}
            <strong>TCVN 10584:2014</strong>.
          </p>
          <div className="nbx-cta">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                props.onOpen();
              }}
              className="btn btn-gradient"
            >
              Certificate
            </button>
          </div>
        </div>

        {/* subtle deco */}
      </section>

      {/* GALLERY 3 ảnh */}
      <section className="nbx-gallery container">
        <img src="/images/proper/gl1.jpg" alt="newborn 1" />
        <img src="/images/proper/gl2.jpg" alt="newborn 2" />
        <img src="/images/proper/gl3.jpg" alt="newborn 3" />
      </section>

      {/* QUOTE BAND */}
      <section className="nbx-quote">
        <div className="container">
          <p className="nbx-sub">BỈM QUẦN RUMI</p>
          <p className="nbx-sub">
            <strong> VỪA VẶN ÊM ÁI, THOẢI MÁI CẢ NGÀY </strong>
          </p>
          <blockquote>
            Tã quần Rumi đạt chứng nhận tiêu chuẩn SGS và TCVN 10584:2014, được
            sản xuất tại nhà máy đạt chuẩn FDA, đảm bảo an toàn tuyệt đối cho
            làn da nhạy cảm của bé. Lấy cảm hứng từ Cụ Rùa ngàn năm Hồ Gươm –
            biểu tượng của sự chở che và tình yêu thuần khiết, Rumi khắc họa
            hình ảnh thiên thần nhỏ trong bộ mai rùa nằm trên mây, gửi gắm thông
            điệp yêu thương Việt đến từng em bé. Với đai chun không áp lực, co
            giãn linh hoạt ôm sát cơ thể, cùng lõi thấm 5 lớp SAP siêu mỏng chỉ
            1,5mm thấm hút nhanh và chống thấm ngược, Rumi giúp bé luôn thoải
            mái trong từng vận động. Bề mặt vải dệt nhiệt siêu mềm, kết hợp cấu
            trúc 3D thoáng khí và vách chống tràn cao 5cm ôm khít, giữ cho da bé
            khô thoáng, dễ chịu suốt ngày dài. Ngoài ra, vạch báo đầy thông minh
            giúp mẹ chăm con tiện lợi và an tâm hơn mỗi ngày.
          </blockquote>
        </div>
      </section>

      <section className="nbx-split container reverse">
        <div className="nbx-col nbx-photo">
          <img src="/images/material/be_mat.jpg" alt="lop be mat" />
          <div className="nbx-badge mint">Vải dệt nhiệt siêu mềm</div>
        </div>
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Lớp Bề Mặt</h2>
          <p>
            Bề mặt tã vân 3D với 5000 lỗ thoáng làm giảm điểm tiếp xúc, giúp bề
            mặt siêu thoáng khí.
          </p>
          <p>
            Chất liệu vải dệt nhiệt siêu mềm mịn nên khi tiếp xúc với da không
            cọ xát khiến con khó chịu hay làm tấy đỏ da.
          </p>
        </div>
      </section>

      <section className="nbx-split container">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Đai chun</h2>
          <p>
            <strong>Đai chun không áp lực </strong> cho bé cảm nhận được sự êm
            ái tuyệt đối, co giãn linh hoạt, ôm sát cơ thể nhưng vẫn thoải mái
            vận động.
          </p>
        </div>
        <div className="nbx-col nbx-photo">
          <img src="/images/material/dai_chun.jpg" alt="" />
          <div className="nbx-badge">Đai chun không áp lực</div>
        </div>
      </section>

      {/* FEATURES – so le ảnh & chữ */}

      <section id="features" className="nbx-split container loitham">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Lớp Lõi Thấm</h2>
          <p>
            Lõi thấm có cấu tạo 5 lớp với hàm lượng cao các hạt SAP, giúp thấm
            hút cực nhanh và chống thấm ngược ngay lập tức sau khi thấm hút.
          </p>
          <img
            src="/images/material/5lop.jpg"
            alt="cau tao"
            className="cau_tao"
          />
          <div className="nbx-badge">
            Thấm hút cực nhanh và chống thấm ngược
          </div>
        </div>
        <div className="nbx-col nbx-text backarea">
          <p>
            Công nghệ sản xuất hiện đại nhất hiện nay giúp sản phẩm đạt được độ
            siêu mỏng (chỉ 1,5mm) và siêu nhẹ.
          </p>
          <img
            src="/images/material/15.jpg"
            alt="mong 1,5mm"
            className="cau_tao"
          />
          <div className="nbx-badge">Siêu mỏng chỉ 1,5mm</div>
        </div>
      </section>

      <section className="nbx-split container reverse">
        <div className="nbx-col nbx-photo">
          <img
            src="/images/material/vach_chong_tran.jpg"
            alt="vach_chong_tran"
          />
          <div className="nbx-badge mint">Vách chống tràn 5cm</div>
        </div>
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Vách chống tràn</h2>
          <p>
            <strong>Vách chống tràn 5cm </strong>
            được thiết kế hai bên ôm sát đùi, đảm bảo chống tràn tuyệt đối, giúp
            bé vận động linh hoạt đồng thời không gây hại cho chân bé.
          </p>
          <p>
            Vạch chỉ báo mức nước tiểu giúp mẹ dễ theo dõi và thay tã cho bé.
          </p>
        </div>
      </section>

      <section className="nbx-split container reverse rr">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">
            Miếng cuộn bỉm thông minh
            <span>
              <img src="/images/material/sun.png" alt="cloud" className="sun" />
            </span>
          </h2>
          <p>
            Thiết kế miếng cuộn bỉm ở mặt sau hay còn được gọi là dải băng dính
            cuốn tã sau khi dùng. Sau khi thay tã cho bé, mẹ chỉ cần cuộn miếng
            tã rồi cố định lại với dải băng dính.
          </p>
        </div>
      </section>

      {/* GUIDE */}
      <section id="guide" className="nbx-card nbx-split container">
        <div className="nbx-col nbx-text">
          <h2 className="hd border-bottom">Hướng dẫn sử dụng</h2>
          <p>
            Để thay tã quần cho bé, ba mẹ hãy tham khảo và làm theo các bước
            sau:
          </p>

          <p>
            <strong>Bước 1: </strong>
          </p>
          <p>
            Luồn tay xuống phía dưới bỉm, nhẹ nhàng căng 2 bên để tạo form
            trước.
          </p>

          <p>
            <strong>Bước 2:</strong>
          </p>
          <p>
            Xỏ từng chân bé vào 2 ống quần bỉm, thao tác từ từ để bé không giật
            mình.
          </p>

          <p>
            <strong>Bước 3:</strong>
          </p>
          <p>
            Kéo bỉm lên ngang bụng, điều chỉnh vách chống tràn sao cho vách nằm
            ngoài chun đùi, giúp ngăn tràn hiệu quả.
          </p>

          <p>
            <strong>Bước 4:</strong>
          </p>
          <p>
            Khi vạch báo tã đầy, xé đường hông bỉm để tháo và thay bỉm mới cho
            con.
          </p>
        </div>
        <div className="nbx-col nbx-photo">
          <img
            className="nb_thayta"
            src="/images/material/thaytaquan.jpg"
            alt="huong dan thay ta quan"
          />
          <div className="nbx-badge">Hướng dẫn thay bỉm quần Rumi</div>
        </div>
      </section>

      {/* CTA */}
      <section id="buy" className="nbx-ctaBand">
        <div className="container">
          <h3>Bạn muốn mua tại shop?</h3>
          <Link to="/shop" className="btn btn-gradient large">
            Tìm Shop
          </Link>
        </div>
      </section>
    </main>
  );
}
